import styled from 'styled-components';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Small } from 'foundations-components/transitional/components/Small';
import { Text } from 'foundations-components/components/Text';

// @ts-expect-error no types
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UserNameContainer = styled.div.withConfig({
  displayName: "UserAvatar__UserNameContainer",
  componentId: "sc-86g579-0"
})(["-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;"]);
export default function UserAvatar({
  email,
  name
}) {
  const emailJsx = /*#__PURE__*/_jsx(Text, {
    as: "span",
    color: "text-primary-disabled",
    children: email
  });
  return /*#__PURE__*/_jsxs(Media, {
    align: "center",
    "data-test-id": "user-avatar",
    children: [email && /*#__PURE__*/_jsx(MediaLeft, {
      children: /*#__PURE__*/_jsx(UIAvatar, {
        displayName: email,
        lookup: {
          type: 'hubSpotUserEmail',
          primaryIdentifier: email
        }
      })
    }), /*#__PURE__*/_jsxs(MediaBody, {
      children: [/*#__PURE__*/_jsx(UserNameContainer, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "span",
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: name
          })
        })
      }), email && /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(TruncateString, {
          tooltip: emailJsx,
          children: emailJsx
        })
      })]
    })]
  });
}